import { PayPalFile } from '../../../typings'
import { COVER_IMAGE_ALTERNATE_DEFAULT_IMAGE_URLS } from '../constants'
import { groupApi } from './groupApi'

export interface ImageMedia {
  url: string
  name: string
  isCustom?: boolean
  isNew?: boolean
  alternateDefaultUrls?: string[]
}

export const getMediaFilesApiSlice = groupApi.injectEndpoints({
  endpoints: (builder) => ({
    getMediaFiles: builder.query<ImageMedia[], { category: string }>({
      query: ({ category }) => ({
        url: `/mediaFiles?category=${category}`,
      }),
      transformResponse: (response: PayPalFile[]) => {
        return response.map((file) => ({
          url: file.file.referenceUrl,
          name: file.description,
          isCustom: false,
          isNew: false,
          alternateDefaultUrls: COVER_IMAGE_ALTERNATE_DEFAULT_IMAGE_URLS,
          contentType: file.file.contentType,
        }))
      },
    }),
  }),
})

export const updateMediaFilesQuery = (updatedPhotos: ImageMedia[]) => {
  return getMediaFilesApiSlice.util.updateQueryData(
    'getMediaFiles',
    { category: 'ALL' },
    (_draftData) => {
      return updatedPhotos
    },
  )
}

export const { useGetMediaFilesQuery } = getMediaFilesApiSlice
